<template>
  <div class="content">
    <van-nav-bar title="户号详情" />
    <!-- <div class="title"> -->
    <div class="title_name">
      <div class="title_content">
        <van-icon :name="require('../assets/room2.png')"
                  color="#696136" />
        <div class="title_info">
          {{openInfo.roomName}}
        </div>
      </div>
      <van-button class="cancelRoom"
                  size="small"
                  plain
                  type="info"
                  @click="cancelRoom">解绑</van-button>

    </div>
    <!-- </div> -->
    <van-tabs @click="onClick">
      <van-tab title="余额">
        <div class="water">
          <div class="water_title">
            水费余额
          </div>
          <div class="water_money">
            {{wBalance}}
            <span>元</span>
          </div>
          <div class="water_btn">

            <span @click="goInfo('W')">明细</span>
            <van-button round
                        type="info"
                        size="normal"
                        @click="pay('W',wBalance)">充值</van-button>
          </div>
        </div>

        <div class="dian">
          <div class="dian_title">
            电费余额
          </div>
          <div class="dian_money">
            {{eBalance}}
            <span>元</span>
          </div>
          <div class="dian_btn">

            <span @click="goInfo('E')">明细</span>
            <van-button round
                        type="info"
                        size="normal"
                        @click="pay('E',eBalance)">充值</van-button>
          </div>
        </div>
      </van-tab>
      <van-tab title="剩余用量">
        <div class="water">
          <div class="water_title">
            剩余用水量
          </div>
          <div class="water_money">
            {{wSurplus}}
            <span>吨</span>
          </div>
          <div class="water_btn">

            <span @click="goInfo('W')">明细</span>
            <van-button round
                        type="info"
                        size="normal"
                        @click="pay('W',wBalance)">充值</van-button>
          </div>
        </div>

        <div class="dian">
          <div class="dian_title">
            剩余用电量
          </div>
          <div class="dian_money">
            {{eSurplus}}
            <span>度</span>
          </div>
          <div class="dian_btn">

            <span @click="goInfo('E')">明细</span>
            <van-button round
                        type="info"
                        size="normal"
                        @click="pay('E',eBalance)">充值</van-button>
          </div>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
export default {
  data() {
    return {
      openInfo: {
      },
      wBalance: 0,
      wSurplus: 0,
      eBalance: 0,
      eSurplus: 0
    }
  },
  mounted() {

    // 进入详情界面之前获取openId
    this.openInfo = JSON.parse(window.sessionStorage.getItem('openInfo'))
    // 如果是直接进入的detail页面（没有openId) 或者有openId但是没有绑定房间-- - 回退到home界面重新获取
    if (this.openInfo == null || this.openInfo.roomId == null) {
      this.$toast('户号信息获取失败....')
      this.$router.push('/home3')
    } else {
      // 当前openId已经绑定过房间号 进行余额查询
      this.getBalance(this.openInfo.roomId, 'SF')

      this.getBalance(this.openInfo.roomId, 'DF')
    }

  },
  methods: {
    // onClickLeft() {
    //   this.$router.push('/home2')
    // },
    pay(type, balance) {
      window.sessionStorage.setItem('infoType', type)
      window.sessionStorage.setItem('balance', balance)
      this.$router.push('/pay')
    },
    goInfo(type) {
      window.sessionStorage.setItem('infoType', type)
      this.$router.push('/info')
    },
    // 解绑
    cancelRoom() {
      this.$dialog.confirm({
        message: '是否要解绑当前户号?',
      }).then(() => {
        this.$axios.post('/wx/setRoomUnBD?openId=' + this.openInfo.openId).then(res => {
          console.log(res)
          if (res.code == 200) {
            this.$notify({
              type: 'success',
              message: '解绑成功!'
            });
            // sessionStorage.clear()
            this.openInfo.roomId = null
            window.sessionStorage.setItem('openInfo', JSON.stringify(this.openInfo))
            let type = window.localStorage.getItem('type')
            this.$router.push('/home3?type=' + type)
          } else {
            this.$notify('解绑失败');
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        console.log('cancel')
      })
    },
    // 查询余额
    getBalance(roomId, type) {
      this.$axios.post('/room/getRoomBalance?roomId=' + roomId + '&type=' + type).then(res => {
        if (res.code == 200) {
          if (type == 'SF') {
            this.wBalance = res.object.balance
            this.wSurplus = res.object.surplus
          } else if (type == 'DF') {
            this.eBalance = res.object.balance
            this.eSurplus = res.object.surplus
          }
        } else {
          this.$toast({
            type: 'fail',
            message: res.message
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }

  },
  // 进入详情页面时候获取房间详情信息
  created() {

  }

}
</script>

<style scoped lang="less" >
.content {
  height: 100%;
  background: #f7f7fc;

  /deep/ .van-tabs__wrap {
    margin: 10px;
  }
}

.title_name {
  align-items: center;
  background: rgb(47, 131, 245);
  background: linear-gradient(
    90deg,
    rgba(47, 131, 245, 0.955284274354273) 0%,
    rgba(148, 187, 233, 1) 100%
  );
  margin: 15px 10px 10px 10px;
  // height: 50px;
  border-radius: 10px;
  text-align: start;
  padding: 15px 10px 15px 10px;

  // height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 25px;
  font-weight: 600;
  color: white;
  // letter-spacing: 4px;

  .title_info {
    font-size: 19px;
    margin-left: 5px;
    width: 90%;
    word-wrap: break-word;
  }

  .title_content {
    width: 85%;
    display: flex;
    align-items: center;
  }
}

.title_address {
  color: white;
  margin-top: 7px;
  font-weight: 500;
  font-size: 17px;
}

.title_status {
  border-radius: 10px;
  margin-top: 12px;
  padding: 3px 0;
  height: 55px;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
}

.status_title {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title1 {
  margin-top: 4px;
  color: white;
  font-weight: 700;
  font-size: 15px;
}

.title2 {
  margin-top: 4px;
  background: white;
  padding: 1px 8px;
  font-weight: 500;
  color: #88cdff;
}

.water,
.dian {
  height: 140px;
  border-radius: 10px;
  margin: 15px 10px 10px 10px;
  padding: 15px 5px 28px 15px;
  // background: rgb(146, 150, 157);
  // background: linear-gradient(
  //   90deg,
  //   rgba(146, 150, 157, 0.955284274354273) 0%,
  //   rgba(180, 181, 182, 1) 100%
  // );
}

.water {
  background: #4373ff;
}

.dian {
  background: #42485b;
}

.water_title,
.dian_title {
  color: white;
  text-align: start;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

.water_money,
.dian_money {
  color: white;
  text-align: start;
  margin-top: 5px;
  font-size: 28px;
  margin-bottom: 20px;

  > span {
    font-size: 22px;
    font-weight: 600;
  }
}

.water_btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: white;
  > span {
    margin-top: 10px;
    font-weight: 500;
  }
}

.dian_btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: white;

  > span {
    margin-top: 10px;
    font-weight: 500;
  }
}
.water_btn .van-button {
  background: white;
  color: #4373ff;
  font-weight: 500;
  width: 100px !important;
  height: 36px;
  margin: 10px 10px 0 20px;
  border: none;
}

.dian_btn .van-button {
  background: white;
  color: #42485b;
  font-weight: 500;
  width: 100px !important;
  height: 36px;
  margin: 10px 10px 0 20px;
  border: none;
}
</style>